import { render } from "./CoursesPrograms.vue?vue&type=template&id=a9890292"
import script from "./CoursesPrograms.vue?vue&type=script&lang=js"
export * from "./CoursesPrograms.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__